import React, { useCallback, useState } from 'react';
import CardRow from '../CardRow/CardRow';
import CardCol from '../CardCol/CardCol';

const CardsList = ({
  menuRef,
  listMode,
  videos,
  folder,
  isUserHasEditingRights,
  isUserHasAdvancedEditingRights,
  searchInput,
  toggleShowMenu,
  renameVideoData = {},
  renameVideo,
  handleCopyClick,
  shareVideo,
  removeFromReview,
  duplicateVideo,
  downloadVideo,
  archiveVideos,
  unarchiveVideo,
  handleDotsClick,
  showMenu,
  onRenameInputChange,
  handleCardClick,
  deleteVideo,
  renameVideoAction,
  approveVideo,
  declineVideo,
  revokeVideo,
  moveVideoAction,
  isMobileView,
  squeezeCard,
  isShowApprovalStatus,
  hideActions,
  alt = '',
}) => {
  const getRedirectLink = useCallback(
    (video, folder) => {
      if (!isMobileView && video.draft && video.videoHls === null) {
        return {
          pathname: `/eg/storyboard/${video.id}`,
        };
      }

      if (hideActions && video?.videoLink) {
        return null;
      }

      return {
        pathname: `/eg/video/${video.id}`,
        state: { archive: video.archived, folder },
      };
    },
    [isMobileView, hideActions]
  );

  return (
    <>
      {videos &&
        videos.map((video, videoIndex) =>
          listMode ? (
            <CardRow
              key={video.id}
              menuRef={menuRef}
              listMode={listMode}
              video={video}
              folder={folder}
              videoIndex={videoIndex}
              searchInput={searchInput.query}
              showMenu={showMenu}
              toggleShowMenu={toggleShowMenu}
              onRenameInputChange={onRenameInputChange}
              renameVideoData={renameVideoData}
              renameVideo={renameVideo}
              handleCopyClick={handleCopyClick}
              shareVideo={shareVideo}
              removeFromReview={removeFromReview}
              duplicateVideo={duplicateVideo}
              downloadVideo={downloadVideo}
              archiveVideos={archiveVideos}
              handleDotsClick={handleDotsClick}
              handleCardClick={handleCardClick}
              deleteVideo={deleteVideo}
              renameVideoAction={renameVideoAction}
              approveVideo={approveVideo}
              declineVideo={declineVideo}
              revokeVideo={revokeVideo}
              moveVideoAction={moveVideoAction}
              unarchiveVideo={unarchiveVideo}
              isMobileView={isMobileView}
              isUserHasEditingRights={isUserHasEditingRights}
              isUserHasAdvancedEditingRights={isUserHasAdvancedEditingRights}
              getRedirectLink={getRedirectLink}
              hideActions={hideActions}
              alt={alt}
            />
          ) : (
            <CardCol
              key={video.id}
              menuRef={menuRef}
              listMode={listMode}
              video={video}
              hideActions={hideActions}
              folder={folder}
              videoIndex={videoIndex}
              searchInput={searchInput.query}
              showMenu={showMenu}
              toggleShowMenu={toggleShowMenu}
              onRenameInputChange={onRenameInputChange}
              renameVideoData={renameVideoData}
              renameVideo={renameVideo}
              handleCopyClick={handleCopyClick}
              shareVideo={shareVideo}
              removeFromReview={removeFromReview}
              duplicateVideo={duplicateVideo}
              downloadVideo={downloadVideo}
              archiveVideos={archiveVideos}
              handleDotsClick={handleDotsClick}
              handleCardClick={handleCardClick}
              deleteVideo={deleteVideo}
              renameVideoAction={renameVideoAction}
              approveVideo={approveVideo}
              declineVideo={declineVideo}
              revokeVideo={revokeVideo}
              moveVideoAction={moveVideoAction}
              unarchiveVideo={unarchiveVideo}
              isMobileView={isMobileView}
              squeezeCard={squeezeCard}
              isUserHasEditingRights={isUserHasEditingRights}
              isUserHasAdvancedEditingRights={isUserHasAdvancedEditingRights}
              isShowApprovalStatus={isShowApprovalStatus}
              getRedirectLink={getRedirectLink}
              alt={alt}
            />
          )
        )}
    </>
  );
};

export default CardsList;
